import axios from 'axios';

export const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

console.log('API Base URL:', BASE_URL);

const api = axios.create({
  baseURL: `${BASE_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000,
});

// Held here in module scope and attached by the interceptor below. AuthContext
// owns it (login/logout/401) and restores it from sessionStorage on startup -
// see the note there for why sessionStorage rather than memory or localStorage.
let authToken = null;

export function setAuthToken(token) {
  authToken = token;
}

api.interceptors.request.use((config) => {
  if (authToken) {
    config.headers.Authorization = `Bearer ${authToken}`;
  }
  return config;
});

// AuthContext registers itself here so a 401 from any request (expired/
// invalid token) can trigger a single global "log out and go to login"
// reaction without api.js importing React/router directly.
let unauthorizedHandler = null;

export function setUnauthorizedHandler(handler) {
  unauthorizedHandler = handler;
}

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401 && unauthorizedHandler) {
      unauthorizedHandler();
    }
    return Promise.reject(error);
  }
);

// Every download route now requires the same Authorization header as any
// other API call, but a plain <a href="..."> is a bare browser navigation
// that never goes through the axios interceptor above - it always fails
// auth. Fetch the file through axios instead (so the token is attached)
// and hand the browser a client-side blob URL to save.
export function downloadFile(url, filename, params) {
  return api.get(url, { responseType: 'blob', params }).then((res) => {
    const blobUrl = URL.createObjectURL(res.data);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(blobUrl);
  });
}

export default api;
